/**
 * Tracks tables where the player has declined the idle "Buy Back In" prompt.
 *
 * When a seated player goes idle past the engine's buy-in timer, the client
 * stands them up and shows the Buy Back In modal (pages/Game.tsx). If the
 * player declines (Exit Table) they're sent to the lobby. Unity does NOT
 * re-prompt when they re-open that table — they observe and see the normal
 * Join Table button. Without this flag the client re-fired the prompt on
 * every re-open, trapping the player in a rebuy loop.
 *
 * The flag is per-gameID and cleared when the player buys back in, or when the
 * engine resets the idle trigger (triggerBuyIn === -1) for a fresh session.
 */
const STORAGE_KEY = 'buyBackInDeclined';

export function isBuyBackInDeclined(gameID: string | number | undefined | null): boolean {
  const key = String(gameID ?? '');
  if (!key) return false;
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return !!stored?.[key];
  } catch {
    return false;
  }
}

export function markBuyBackInDeclined(gameID: string | number | undefined | null): void {
  const key = String(gameID ?? '');
  if (!key) return;
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    stored[key] = true;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {
    /* localStorage unavailable — fail open; the prompt may re-appear, no worse
       than the pre-fix behaviour. */
  }
}

export function clearBuyBackInDeclined(gameID: string | number | undefined | null): void {
  const key = String(gameID ?? '');
  if (!key) return;
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    if (key in stored) {
      delete stored[key];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    }
  } catch {
    /* noop */
  }
}
